export const CIRCLES_STATS = [
  { value: "120+", label: "Active circles" },
  { value: "23k+", label: "Members reading" },
  { value: "4.8", label: "Avg discussion rating" },
  { value: "Weekly", label: "Highlight cadence" },
];

export const CIRCLES_PILLARS = [
  {
    title: "Small by design",
    desc: "Most circles cap at 8–20 members so conversations stay personal — not lost in a feed of hundreds.",
  },
  {
    title: "Spoiler-safe threads",
    desc: "Chapter lanes, pinned norms, and gentle moderation keep late joiners welcome without ruining the plot.",
  },
  {
    title: "Weekly highlights",
    desc: "Share one passage, one question, or one recommendation — low effort, high warmth.",
  },
];

export const FEATURED_CIRCLES = [
  {
    id: "late-train",
    name: "Late Train Book Club",
    tag: "Open",
    members: "18 members",
    theme: "Literary fiction & quiet endings",
    desc: "Weeknight readers who love trains, rain, and morally complicated protagonists.",
    longDesc:
      "We meet in threads, not video calls — one highlight per week, optional live chat on Fridays. Currently reading a coastal family saga with a wry narrator.",
    tags: ["Fiction", "Discussion", "Evenings"],
    cadence: "Weekly highlights",
    shelfSlug: "the-quiet-shelf",
  },
  {
    id: "soft-sci-fi",
    name: "Soft Sci-Fi Salon",
    tag: "Trending",
    members: "24 members",
    theme: "Hopeful speculative fiction",
    desc: "Science fiction that cares about people more than gadgets — solarpunk welcome.",
    longDesc:
      "Monthly pick voted by members, with spoiler threads per chapter. Last month’s book sparked a forty-comment thread about found families on generation ships.",
    tags: ["Sci-fi", "Hopeful", "Voting"],
    cadence: "Monthly pick",
    shelfSlug: "reader-circles",
  },
  {
    id: "essays-dusk",
    name: "Essays at Dusk",
    tag: "Loved",
    members: "12 members",
    theme: "Memoir & observational essays",
    desc: "Twenty-minute reading sips — one essay per sitting, always with tea.",
    longDesc:
      "No pressure to finish a full book every month. We trade favorite sentences and write short responses — more letter than review.",
    tags: ["Essays", "Memoir", "Slow"],
    cadence: "Bi-weekly essay",
    shelfSlug: "letters-and-tea",
  },
  {
    id: "weekend-escape",
    name: "Weekend Turners",
    tag: "New",
    members: "31 members",
    theme: "Page-turners for Saturdays",
    desc: "Propulsive fiction finished between lunch and bedtime — spoilers allowed after Sunday.",
    longDesc:
      "Arjun’s Weekend Escape shelf is our north star. Fast votes, fast reads, zero guilt about reading instead of chores.",
    tags: ["Thriller", "Romance", "Weekend"],
    cadence: "Weekend sprint",
    shelfSlug: "weekend-escape",
  },
  {
    id: "cozy-mystery",
    name: "Cozy Mystery Guild",
    tag: "Cozy",
    members: "15 members",
    theme: "Gentle mysteries, no gore",
    desc: "Small-town sleuths, bookshops, and crimes solved over scones.",
    longDesc:
      "We keep a shared shelf of approved cozies and flag anything too dark before it becomes the monthly pick. Rain sounds playlist optional.",
    tags: ["Mystery", "Cozy", "Bookshop"],
    cadence: "Monthly mystery",
    shelfSlug: "rainy-day-reads",
  },
  {
    id: "timeless-voices",
    name: "Slow Canon Club",
    tag: "Classic",
    members: "9 members",
    theme: "One classic per season",
    desc: "Books that outlasted the hype — read slowly, discuss deeply.",
    longDesc:
      "Nine members, one book per quarter, chapter-by-chapter threads. Perfect if you want company without a crowded room.",
    tags: ["Classics", "Slow read", "Deep dive"],
    cadence: "Quarterly classic",
    shelfSlug: "timeless-voices",
  },
];

export const CIRCLE_TYPES = [
  "All circles",
  "Open",
  "Trending",
  "Fiction",
  "Essays",
  "Cozy",
  "Classic",
];

export const CIRCLES_HOW_IT_WORKS = [
  {
    step: "01",
    title: "Find your people",
    body: "Browse open circles by mood, genre, or reading pace. Read the welcome note to see if the vibe fits before you join.",
  },
  {
    step: "02",
    title: "Share a highlight",
    body: "Post a favorite line, a question, or a quiet reaction — no need for long reviews. Circles run on generosity, not performance.",
  },
  {
    step: "03",
    title: "Grow together",
    body: "Vote on the next read, save titles to your shelf, and let the circle’s energy guide what you pick up next.",
  },
];

export const CIRCLES_FAQ = [
  {
    q: "How is a circle different from a shelf?",
    a: "A shelf is a curated book list. A circle is the living conversation around those books — members, threads, and weekly highlights.",
  },
  {
    q: "Do I have to read the same book as everyone?",
    a: "Most circles pick a shared read, but some allow parallel picks within a theme. Check the circle’s pinned welcome note.",
  },
  {
    q: "Can I start my own circle?",
    a: "Yes. Set a name, a short description, visibility (open or invite-only), and invite friends or open it to the PagePeers community.",
  },
  {
    q: "What if I fall behind?",
    a: "Spoiler lanes exist for a reason. Lurk until you catch up, or jump into the threads for the chapters you have finished.",
  },
  {
    q: "Are circles free?",
    a: "Joining and participating in public circles is free with a PagePeers account. Hosting advanced circle tools may be part of premium tiers.",
  },
];

export const CIRCLES_TESTIMONIALS = [
  {
    quote:
      "My circle feels like a group chat with people who actually finish books — and remember the good parts.",
    author: "Neha S.",
    role: "Late Train Book Club",
  },
  {
    quote:
      "I lurked for two weeks before posting. Nobody minded. That is the whole point.",
    author: "Arjun M.",
    role: "Weekend Turners",
  },
  {
    quote:
      "Spoiler threads saved my reading life when I joined Soft Sci-Fi Salon mid-month.",
    author: "Priya R.",
    role: "Soft Sci-Fi Salon",
  },
];
